window.storeTheme = window.storeTheme || ({} as StoreTheme);

const format = {
  money: (price: number, showFreeString = true): string => {
    if (price === 0 && showFreeString) {
      return 'Grátis';
    }

    if (isNaN(price)) {
      return '';
    }

    return price.toLocaleString(window.localeInfo.CultureCode || 'pt-BR', {
      style: 'currency',
      currency: window.localeInfo.CurrencyLocale.ISOCurrencySymbol || 'BRL',
    });
  },
};

Object.assign(window.storeTheme, { helpers: Object.assign(window.storeTheme.helpers || {}, { format }) });

export default format;
